import * as React from "react"
import {useSignal} from "@preact/signals-react";
import {IconSeeker, ImageSeeker, ModalSeeker} from "@ui-seeker/core";
import {Box, Grid, Typography} from "@mui/material";

import ProductPagesModalSkuBlock from "../SkuBlock";


export default function ProductPagesDetailsVideosModal({ isOpen, controller, data }) {
	const currentPos = useSignal(0)
	const videos = data.videos

	let videoUrlFormatted = videos[currentPos.value]?.originalURL || ''
	const isYoutubeVideo = !!videoUrlFormatted && (videoUrlFormatted.includes('.youtube.') || videoUrlFormatted.includes('youtu.be') || videoUrlFormatted.includes('youtube-nocookie.'))
	const isVimeoVideo = !!videoUrlFormatted && videoUrlFormatted.includes('vimeo')

	if (isYoutubeVideo && (videoUrlFormatted.includes('//youtu.be/') || videoUrlFormatted.includes('oembed?url='))) {
		let youtubeID = videoUrlFormatted.split("youtu.be/")[1]
		if (!youtubeID)
			youtubeID = videoUrlFormatted.split("watch%3Fv%3D")[1]
		if (youtubeID.includes('&'))
			youtubeID = youtubeID.split('&')[0]
		videoUrlFormatted = `https://www.youtube.com/watch?v=${youtubeID}`
	} else if (isYoutubeVideo && videoUrlFormatted.includes('/v/')) {
		let youtubeID = videoUrlFormatted.split("/v/")[1]
		if (youtubeID.includes('?'))
			youtubeID = youtubeID.split('?')[0]
		videoUrlFormatted = `https://www.youtube.com/watch?v=${youtubeID}`
	}

	return <ModalSeeker
		hideActions
		isOpen={isOpen}
		controller={controller}
		size="md"
		title='Videos in gallery'
	>
		<Grid container spacing={3}>
			<Grid item xs={12}>
				<ProductPagesModalSkuBlock
					date={data.date}
					company={data.company}
					category={data.category}
					productID={data.productID}
					siteID={data.siteID}
					sku={data.skuName}
					brand={data.brand}
					country={data.country}
					retailer={data.retailer}
					siteURL={data.siteURL}
					ean={data.ean}
					supertitle={data.supertitle}
					productTitle={data.productTitle}
					subtitle={data.subtitle}
					brandRaw={data.brand}
				/>
			</Grid>
		</Grid>

		<Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
			{!isYoutubeVideo && !isVimeoVideo && <Box sx={{ textAlign: 'center' }}>
				<Typography>
					<IconSeeker icon="info-circle" iconWeight="regular" /> This is not a Youtube video, it may not be played
				</Typography>
				<video style={{ maxWidth: '600px', maxHeight: '600px', paddingTop: '20px' }} controls>
					<source src={videoUrlFormatted} type="video/mp4" />
				</video>
			</Box>}

			{isVimeoVideo && <Box>
				<Box style={{ maxWidth: '600px', maxHeight: '600px', margin: 'auto', paddingBottom: '20px' }}>
					<Typography>This is a Vimeo video that can not be played</Typography>
				</Box>
			</Box> }

			{ isYoutubeVideo &&  <iframe
				width="600px"
				height="600px"
				src={videoUrlFormatted.replace('/watch?v=', '/embed/')}
				title="Youtube Video"
				allowFullScreen
			/> }
		</Grid>

		<Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', gap: .5, cursor: 'pointer', flexWrap: 'wrap' }}>
			{ videos.map(({ position }, idx) => <Box
				key={idx}
				onClick={() => currentPos.value = idx}
				sx={{ ...idx === currentPos.value && {
					border: '3px solid',
					borderColor: 'primary.main'
				}}}
			>
				<ImageSeeker src="/images/Video.jpg" sx={{ height: 50 }} />
			</Box>) }
		</Grid>
	</ModalSeeker>
}